import { createAction } from '@ngrx/store';

export const GET_APP_INITIALIZATION = 'GET_APP_INITIALIZATION';
export const GET_APP_INITIALIZATION_SUCCESS = 'GET_APP_INITIALIZATION_SUCCESS';
export const GET_APP_INITIALIZATION_FAILURE = 'GET_APP_INITIALIZATION_FAILURE';

export const getAppInitializationRequest = createAction(GET_APP_INITIALIZATION);

export const getAppInitializationSuccess = createAction(
  GET_APP_INITIALIZATION_SUCCESS
);

export const getAppInitializationFailure = createAction(
  GET_APP_INITIALIZATION_FAILURE
);
